/* @prettier */
import {root, source, spawn, template} from '@acng/frontend-stargazer';
import {join} from '@acng/frontend-bounty/std/array.js';
import {split} from '@acng/frontend-bounty/std/string.js';
import {replaceContent} from '@acng/frontend-bounty/dom/template.js';
import {fetchSVG} from '@acng/frontend-bounty/fetch.js';
import {adoptNode, cloneNode} from '@acng/frontend-bounty';
import {append, remove} from '@acng/frontend-bounty/dom/move.js';
import {query} from '@acng/frontend-bounty/dom/query.js';
import {MapStore} from '@acng/frontend-bounty/collection.js';
import {add} from '@acng/frontend-bounty/style/element.js';
import {asset, INHERIT} from './env.js';
import {set} from '@acng/frontend-bounty/dom/attribute.js';

let DEBUG = false;
// DEBUG: DEBUG = true;

/**
 * @param {string} name
 *
 * @returns {Promise<SVGSVGElement>}
 */
export const getIcon = async (name) => cloneNode(await fetchIcon(name));

const iconFeature = spawn(root, 'icon');

source(iconFeature, async (path) => void (await getIcon(join(path, '/'))));

const assets = import('../../../icon.js').catch(
  /** @returns {typeof import("../../../icon.js")} */
  (e) => ({
    getIconSource: () => {
      throw e;
    },
  }),
);

const defs = (() => {
  const globalSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  set(globalSVG, 'width', '1');
  set(globalSVG, 'height', '1');
  append(document.body, globalSVG);
  const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
  append(globalSVG, defs);

  return defs;
})();

const presets = /** @type {const} */ ([...INHERIT, 'basic']);

/**
 * @type {(pathname: string) => Promise<SVGSVGElement>}
 *
 * @todo
 *
 *   - Remove deprecated `classEntry` without prefix.
 */
const fetchIcon = MapStore(async (pathname) => {
  const {getIconSource} = await assets;
  const url = asset(getIconSource(presets, pathname));
  DEBUG: DEBUG && console.debug(`Fetch icon "${pathname}"...`, {url});

  /** @type {Document & {documentElement: SVGSVGElement}} */
  // @ts-ignore
  const svgDocument = await fetchSVG(url);
  const localDefs = query(svgDocument, 'defs');

  if (localDefs) {
    append(defs, ...localDefs.children);
    remove(localDefs);
  }

  const icon = adoptNode(svgDocument.documentElement);
  const classEntry = pathname.replace('/', '-');

  add(icon, 'icon', `icon-${classEntry}`, classEntry);
  DEBUG: DEBUG && console.debug('...got icon', icon);

  // Put into registry.
  const iconResource = spawn(iconFeature, ...split(pathname, '/'));
  const tpl = template(iconResource);
  replaceContent(tpl, icon);

  return icon;
});
